import { render, staticRenderFns } from "./BlackListModal.vue?vue&type=template&id=63b1d4ce&scoped=true"
import script from "./BlackListModal.vue?vue&type=script&lang=js"
export * from "./BlackListModal.vue?vue&type=script&lang=js"
import style0 from "./BlackListModal.vue?vue&type=style&index=0&id=63b1d4ce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1d4ce",
  null
  
)

export default component.exports